import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import useStyles from './styles';

const Term = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <p className={classes.title}>{t('terms_and_conditions')}</p>
      <p className={classes.textIntroduction}>
        <Trans i18nKey="terms_and_conditions_introduction" />
      </p>

      <p className={classes.textUnderLine}>{t('text_by_validate_this_form')}</p>
      <p className={classes.textTerm}>{t('text_term_1')}</p>
      <p className={classes.textTerm}>{t('text_term_2')}</p>
      <p className={classes.textTerm}>{t('text_term_3')}</p>
      <p className={classes.textTerm}>{t('text_term_4')}</p>
      <p className={classes.textTerm}>{t('text_term_5')}</p>

      <p className={classes.textUnderLine}>{t('liability_of_gladiusart')}</p>
      <p className={classes.textTerm}>{t('text_certificate_footer')}</p>
    </div>
  );
};

export default Term;
